/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A task template associated with a claim status
 * @export
 * @interface TaskTemplate
 */
export interface TaskTemplate {
    /**
     * Unique task template ID
     * @type {number}
     * @memberof TaskTemplate
     */
    readonly id: number;
    /**
     * ID of the parent status template
     * @type {number}
     * @memberof TaskTemplate
     */
    claimStatusTemplateId: number;
    /**
     * Title of the task
     * @type {string}
     * @memberof TaskTemplate
     */
    title: string;
    /**
     * Optional description of the task
     * @type {string}
     * @memberof TaskTemplate
     */
    description?: string | null;
    /**
     * Task priority level
     * @type {string}
     * @memberof TaskTemplate
     */
    priority: TaskTemplatePriorityEnum;
    /**
     * Number of days after status change when task is due
     * @type {number}
     * @memberof TaskTemplate
     */
    dueDaysOffset?: number | null;
    /**
     * Role that should be assigned this task
     * @type {string}
     * @memberof TaskTemplate
     */
    assigneeRole?: string | null;
    /**
     * Order in which tasks should be displayed
     * @type {number}
     * @memberof TaskTemplate
     */
    displayOrder: number;
    /**
     * Whether this task is required to complete the status
     * @type {boolean}
     * @memberof TaskTemplate
     */
    isRequired?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TaskTemplate
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskTemplate
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const TaskTemplatePriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Urgent: 'urgent'
} as const;
export type TaskTemplatePriorityEnum = typeof TaskTemplatePriorityEnum[keyof typeof TaskTemplatePriorityEnum];


/**
 * Check if a given object implements the TaskTemplate interface.
 */
export function instanceOfTaskTemplate(value: object): value is TaskTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimStatusTemplateId' in value) || value['claimStatusTemplateId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TaskTemplateFromJSON(json: any): TaskTemplate {
    return TaskTemplateFromJSONTyped(json, false);
}

export function TaskTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimStatusTemplateId': json['claimStatusTemplateId'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'priority': json['priority'],
        'dueDaysOffset': json['dueDaysOffset'] == null ? undefined : json['dueDaysOffset'],
        'assigneeRole': json['assigneeRole'] == null ? undefined : json['assigneeRole'],
        'displayOrder': json['displayOrder'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function TaskTemplateToJSON(json: any): TaskTemplate {
    return TaskTemplateToJSONTyped(json, false);
}

export function TaskTemplateToJSONTyped(value?: Omit<TaskTemplate, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimStatusTemplateId': value['claimStatusTemplateId'],
        'title': value['title'],
        'description': value['description'],
        'priority': value['priority'],
        'dueDaysOffset': value['dueDaysOffset'],
        'assigneeRole': value['assigneeRole'],
        'displayOrder': value['displayOrder'],
        'isRequired': value['isRequired'],
    };
}

